import React from 'react';
import { TeeLink } from './tee-link';
import { IconEdit } from '@tabler/icons-react';

export interface TeeSectionTitleProps {
  title: string;
  onEdit?: () => void;
  showEdit?: boolean;
  actionLeadingIcon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  /**
   * 'm' (default) is the standard 20px section header used across box-os detail
   * pages. 's' is for a title nested inside an already-titled, denser context
   * (e.g. a sub-section within a wizard step) where the default size reads as
   * oversized relative to its surroundings.
   */
  size?: 's' | 'm';
}

const TeeSectionTitle = React.forwardRef<HTMLDivElement, TeeSectionTitleProps>(
  (
    {
      title,
      onEdit,
      showEdit = false,
      actionLeadingIcon,
      actionLabel,
      onAction,
      className,
      size = 'm',
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`flex items-center justify-between w-full ${className || ''}`}
      >
        <p
          className={
            size === 's'
              ? 'font-[family-name:var(--type-font-family-heading,"Inter:medium",sans-serif)] font-semibold text-[14px] leading-[18px] text-[var(--text-content-sub-title,#6C756D)]'
              : "font-[family-name:var(--type-font-family-heading,'Inter:medium',sans-serif)] font-medium text-heading-h4 leading-[var(--line-height-heading-h4,24px)] text-[var(--text-content-sub-title,#6C756D)]"
          }
        >
          {title}
        </p>
        {actionLabel && onAction && (
          <TeeLink
            variant="primary"
            size="s"
            leftIcon={actionLeadingIcon}
            onClick={onAction}
            href="#"
          >
            {actionLabel}
          </TeeLink>
        )}
        {showEdit && onEdit && (
          <TeeLink
            variant="primary"
            size="s"
            leftIcon={<IconEdit size={14} />}
            onClick={onEdit}
            href="#"
            className="flex items-center gap-1.5"
          >
            Edit
          </TeeLink>
        )}
      </div>
    );
  }
);

TeeSectionTitle.displayName = 'TeeSectionTitle';

export { TeeSectionTitle };
